import {createSlice} from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn: false,
    userInfo: null,
    userName: '',
    branchId: null,
  },
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.userInfo = action.payload;
      state.userName = action.payload;
      state.branchId = action.payload;
    },
    logout: state => {
      state.isLoggedIn = false;
      state.userInfo = null;
      state.userName = '';
      state.branchId = null;
    },
  },
});

// Export actions
export const {login, logout} = userSlice.actions;

// Export reducer
export default userSlice.reducer;
